APPS.landingPages.calendar = (function(){
    var show = function(){
            APP.getView().showChildView('mainRegion', new pageView({}) )
            
            window.document.title = "Calendar Announcements";
            if(typeof ga != "undefined"){ ga('send','pageview',{ title:"Calendar Announcements", page:"/calendar" }) }
			if(typeof gtag != "undefined"){ gtag('event', 'page_view', { 'page_title': "Calendar Announcements", 'page_path': '/calendar', 'page_location': window.location.origin+"/calendar" }); }
            if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, "Calendar Announcements", '0', false, true); }
    }

    /* VIEWS */
    // THE PAGE
    var pageView = Marionette.View.extend({
         template:"#tmpl-landingPage-calendar"
        ,className:"page_landingPage_calendar my8"
        ,events:{
            "click #btnSubmitRequest"			: "submit",
            'blur.error-form  #event_name, #date, #time, #location, #website, #description, #first_name, #last_name, #phone, #email': function(e){
	            var $this = $(e.currentTarget),
				    id = $this.attr('id');
				
				if( !$this.val().length ){
					this.$el.find('#error-'+id).show() 
				}else{
					this.$el.find('#error-'+id).hide() 
				}
            }
        }
        ,submit:function(e){
	        e.preventDefault();
	        $('#messageContainer').hide();
			
			var formData = new FormData($('form')[0]);
			var errors = [], i = 0;
			var iterator, end=false;
			
			 //formData is difficult to console out without ES6 :p
			iterator = formData.entries();
			while(end === false) {
				var item = iterator.next();
				if(item.value!==undefined) {
					if(item.value[0] === "email"){
						if(item.value[1] === "" || !(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(item.value[1]))){
							errors[i++] = item.value[0];
						}
					} else if(item.value[0] === "event_name" ||
							 item.value[0] === "date" ||
							 item.value[0] === "location" ||
							  item.value[0] === "website" ||
							  item.value[0] === "description" ||
							  item.value[0] === "first_name" ||
							  item.value[0] === "last_name" ||
							  item.value[0] === "phone")
							  {
								if(item.value[1] === ""){
									errors[i++] = item.value[0];
								};
					}
				} else if(item.done===true) {
					end = true;
				}
			}
			
			if(errors.length > 0){
				_.each(errors, function(item){
					$("#error-"+item).show();
				})
				
			}
			if(errors.length == 0){
				$.ajax({
					url: APP_CONFIG.MEDIA_API_ROOT+'calendar',
					data: formData,
					processData: false,
					contentType: false,
					type: 'POST'
				}).done(function(res){
					if(res){
						var response = JSON.parse(res);						
						if(response.success === true){
							Backbone.Radio.channel('calendar').request("confirmation", {status: true});
						} else {
							var htm = "<h2 class='my4 danger'>Umm... there is an error.</h2>"
							htm += "<h2 class='my4 danger'>Please fill out fields.</h2>"
							$('#messageContainer').html(htm).show();
						}
							
					} else {
						var htm = "<h2 class='my4 danger'>Unknown error.</h2>"
						$('#messageContainer').html(htm).show();
					}
					
				});			
			}


        }
    })
    return {
        show:show
    }
})();


/// Confirmation page for Listener show request 
APPS.landingPages.calendarConfirmation = (function(){
	var show = function(){
		APP.getView().showChildView('mainRegion', new pageView({}) )
	}
	
			
	var pageView = Marionette.View.extend({
		 template:"#tmpl-landingPage-calendar-confirmation"
		 ,className:"page_landingPage_calendar_confirmation py8"
	}) 
	return {
		show:show
	}
})();




